import { TypeInterface } from "../TypeInterface";
import { Type } from "../Type";
import Translator from "../../../../../Translation/Translator";

class Other extends Type implements TypeInterface  {

  public static contactForContractTypeId: number = 255;
  public static selectable: boolean = true;

  public getName(): string {
    return Translator.trans("contact-for-contract-type-other");
  }

}

export { Other }
